<shared-form-view #formView
  [formGroup]="formGroup()"
  [suggestions]="{}"
  [sections]="sections"
  [pageType]="context().pageType"
  (buttonClick)="onButtonClick($event)">
</shared-form-view>
